<template>
  <article class="px-0 py-0 my-0">
    <section class="px-7 px-xl-9 py-14 m-0">
      <div style="max-width:704px" class="mx-auto">
        <h2 class="by-heading-2 text-by-blue-100 mb-5">Erklärung zur Barrierefreiheit</h2>
        <p class="mb-0 by-copy-large-regular text-by-neutral-100">
          Die byte - Bayerische Agentur für Digitales GmbH (byte) legt großen Wert auf die
          barrierefreie Nutzbarkeit ihres Angebots für alle Bürgerinnen und Bürger sowie Nutzerinnen
          und Nutzer.
          Als öffentliche Stelle im Sinne der Richtlinie (EU) 2016/2102 sind wir bemüht,
          unsere Websites und mobilen Anwendungen zur Umsetzung der Richtlinie
          (EU) 2016/2102 barrierefrei zugänglich zu machen. <br><br>
          Rechtsgrundlage für die barrierefreie Gestaltung ist die Bayerische
          E-Government-Verordnung
          (BayEGovV).
          Diese Erklärung zur Barrierefreiheit gilt für den Internetauftritt unter <a
          href="/">https://open.bydata.de</a>.
        </p>
      </div>
    </section>
    <section class="m-0 py-11 px-7 px-xl-9 bg-by-neutral-10">
      <div style="max-width:704px" class="mx-auto">
        <h3 class="by-heading-3 text-by-blue-100 mb-4">Erstellung dieser Erklärung zur
          Barrierefreiheit</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Diese Erklärung wurde am 27.04.2023 erstellt.<br><br>

          Diese Internetseite wurde vom Open User Lab des Fraunhofer-Instituts für offene
          Kommunikationssysteme nach der Methode des BITV-Tests getestet/überprüft. Geprüft wurden
          die Kriterien nach BITV 2.0 sowie EN 301549 sowie WCAG 2.2. Erforderliche Anpassungen an
          der Webseite werden im Rahmen der laufenden Weiterentwicklungen vorgenommen.
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-4">Stand der Vereinbarkeit mit den
          Anforderungen</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Diese Website ist wegen der folgenden Unvereinbarkeiten teilweise mit WCAG Level A
          vereinbar.
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-4">Nicht barrierefreie Inhalte</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          <ul class="mb-0 pl-4">
            <li>Auf mehreren Seiten sind HTML-Syntax-Fehler vorhanden</li>
            <li>Auf der Detailseite fehlt die logische Verknüpfung von Metadatentitel und
              Metadateninhalt
            </li>
            <li>Die Startseite hat keinen individuellen Dokumenttitel</li>
          </ul>
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-4">Barrieren melden sowie Informationen zur
          Barrierefreiheit dieser
          Website</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">

          Sie möchten uns bestehende Barrieren mitteilen oder Informationen zur Umsetzung der
          Barrierefreiheit erfragen?
          Für Ihr Feedback sowie alle weiteren Informationen sprechen Sie unsere verantwortlichen
          Kontaktpersonen unter <a href="mailto:kontakt@byte.bayern">kontakt@byte.bayern</a> an.

        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-4">Ansprechpartner für die barrierefreie
          Zugänglichkeit ist:</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">

          byte - Bayerische Agentur für Digitales GmbH <br>
          Orleansstraße 24 <br>
          81669 München <br>
          Telefon: +49 89 54194248 <br>
          E-Mail: <a href="mailto:kontakt@byte.bayern">kontakt@byte.bayern</a> <br>

        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-4">Durchsetzungsverfahren</h3>
        <p class="text-by-neutral-100 by-copy-small-regular mb-9">
          Im Rahmen eines Durchsetzungsverfahrens haben Sie die Möglichkeit, online einen Antrag auf
          Prüfung der Einhaltung der Anforderungen an die Barrierefreiheit zu stellen.<br><br>

          Antrag auf Prüfung der Anforderungen an die Barrierefreiheit gem. § 3 BayEGovV können Sie
          hier stellen.<br><br>

          Kontaktdaten der Durchsetzungsstelle:<br>
          Landesamt für Digitalisierung, Breitband und Vermessung<br>
          IT-Dienstleistungszentrum des Freistaats Bayern<br>
          Durchsetzungs- und Überwachungsstelle für barrierefreie Informationstechnik<br><br>
          St.-Martin-Straße 4781541 München<br>
          <a href="mailto:bitv@bayern.de">bitv@bayern.de</a><br>
          <a href="https://www.idbv.bayern.de/digitalisierung/bitv.html">www.idbv.bayern.de/digitalisierung/bitv.html</a><br><br>
        </p>
        <h3 class="by-heading-3 text-by-blue-100 mb-4">Schlichtungsverfahren</h3>
        <p class="text-by-neutral-100 by-copy-small-regular">
          Wenn auch nach Ihrem Feedback an den oben genannten Kontakt keine zufriedenstellende Lösung
          gefunden wurde, können Sie sich an die Schlichtungsstelle nach § 16
          Behindertengleichstellungsgesetz (BGG) wenden. Die Schlichtungsstelle BGG hat die Aufgabe,
          bei Konflikten zum Thema Barrierefreiheit zwischen Menschen mit Behinderungen und
          öffentlichen Stellen des Bundes eine außergerichtliche Streitbeilegung zu unterstützen. Das
          Schlichtungsverfahren ist kostenlos. Es muss kein Rechtsbeistand eingeschaltet werden.
          Weitere Informationen zum Schlichtungsverfahren und den Möglichkeiten der Antragstellung
          erhalten Sie unter: <a href="https://www.schlichtungsstelle-bgg.de/">www.schlichtungsstelle-bgg.de</a>.
        </p>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "Accessibility",
  metaInfo() {
    const title = "Barrierefreiheit - open bydata";
    return {
      titleTemplate(chunk) {
        return title;
      },
    };
  },
}
</script>

<style scoped>
@import "../styles/static_pages.scss";

</style>
